import React from 'react';

const CloseIcon = (props) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.91615 8.50007L12.8099 4.60608C13.0633 4.35279 13.0633 3.94325 12.8099 3.68997C12.5567 3.43668 12.1471 3.43668 11.8939 3.68997L7.99994 7.58396L4.10614 3.68997C3.85274 3.43668 3.44333 3.43668 3.19005 3.68997C2.93665 3.94325 2.93665 4.35279 3.19005 4.60608L7.08385 8.50007L3.19005 12.3941C2.93665 12.6474 2.93665 13.0569 3.19005 13.3102C3.31628 13.4365 3.48225 13.5 3.6481 13.5C3.81395 13.5 3.9798 13.4365 4.10614 13.3102L7.99994 9.41618L11.8939 13.3102C12.0202 13.4365 12.1861 13.5 12.3519 13.5C12.5178 13.5 12.6836 13.4365 12.8099 13.3102C13.0633 13.0569 13.0633 12.6474 12.8099 12.3941L8.91615 8.50007Z"
      fill="currentColor"
    />
  </svg>
);

export default CloseIcon;
